export default __webpack_public_path__ + "static/media/or_3.2558dd68.mp3";